import { UiOption } from '@/lib/helpers';

export type BreadCrumb = 'group' | 'context' | 'policy';

export const BreadCrumbMap: Record<BreadCrumb, UiOption> = {
  group: { label: 'Groups', value: '/config/groups' },
  context: { label: 'Context Datasources', value: '/config/context-sources' },
  policy: { label: 'Group Policies', value: '/config/group-policies' },
};
